import * as Sentry from "@sentry/react";
import { AppProvider } from "@shopify/polaris";
import { PolarisVizProvider } from "@shopify/polaris-viz";
import enTranslations from "@shopify/polaris/locales/en.json";
import React from "react";
import "@shopify/polaris/build/esm/styles.css";
import "#web/assets/styles.css";
import "@shopify/polaris-viz/build/esm/styles.css";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from "react-router-dom";

import { AppComparison } from "./pages/AppComparison";
import { Billing } from "./pages/Billing";
import { Dashboard } from "./pages/Dashboard";
import "./components/sentry/sentryInit";
import { Duplicates } from "./pages/Duplicates";
import { Error404 } from "./pages/Error404";
import { Extensions } from "./pages/Extensions";
import { Leaks } from "./pages/Leaks";
import { LeaksDetails } from "./pages/LeaksDetails";
import { LinkBlockingCreate } from "./pages/LinkBlocking/LinkBlockingCreate";
import { LinkBlockingDetail } from "./pages/LinkBlocking/LinkBlockingDetail";
import { LinkBlockingList } from "./pages/LinkBlocking/LinkBlockingList";
import { Settings } from "./pages/Settings";
import RootLayout from "./RootLayout";

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Root element not found");
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />} path="/">
      <Route element={<Dashboard />} index />
      <Route element={<Leaks />} path="/leaks" />
      <Route element={<LeaksDetails />} path="/leaks/:id" />
      <Route element={<Extensions />} path="/extensions" />
      <Route element={<Duplicates />} path="/duplicates" />
      <Route element={<LinkBlockingList />} path="/linkblocking" />
      <Route element={<LinkBlockingCreate />} path="/linkblocking/create" />
      <Route element={<LinkBlockingDetail />} path="/linkblocking/:id" />
      <Route element={<Settings />} path="/settings" />
      <Route element={<Billing />} path="/billing" />
      <Route element={<AppComparison />} path="/app-comparison" />
      <Route element={<Error404 />} path="*" />
    </Route>,
  ),
);

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <AppProvider i18n={enTranslations}>
        <PolarisVizProvider>
          <RouterProvider router={router} />
        </PolarisVizProvider>
      </AppProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
